import { required, email, minLength } from 'vuelidate/lib/validators'
import { UFS } from '@/globals/staticVars.js'

const formData = {
  'name': {
    size: 6,
    type: 'text',
    name: 'name',
    label: 'Nome completo',
    placeholder: 'Digite seu nome completo',
    value: null
  },
  'gender': {
    size: 3,
    type: 'select',
    name: 'gender',
    label: 'Sexo',
    placeholder: 'Selecione',
    value: null,
    options: [
      {
        id: 'F',
        name: 'Feminino'
      },
      {
        id: 'M',
        name: 'Masculino'
      }
    ]
  },
  'dateOfBirth': {
    size: 3,
    type: 'text',
    name: 'dateOfBirth',
    mask: '##/##/####',
    label: 'Data de nascimento: ',
    placeholder: '  /  /',
    value: null
  },
  'rg': {
    size: 4,
    type: 'text',
    name: 'rg',
    label: 'RG',
    maxlength: 15,
    placeholder: 'Digite seu RG',
    value: null
  },
  'cpf': {
    size: 4,
    offset: 4,
    disabled: true,
    type: 'text',
    name: 'cpf',
    label: 'CPF',
    placeholder: 'Digite seu CPF',
    mask: '###.###.###-##',
    value: null
  },
  'email': {
    size: 4,
    type: 'text',
    name: 'email',
    label: 'E-mail',
    placeholder: 'Digite seu e-mail',
    value: null
  },
  'contactPhone': {
    size: 4,
    offset: 2,
    type: 'text',
    name: 'contactPhone',
    label: 'Telefone',
    mask: ['(##) ####-####', '(##) #####-####'],
    placeholder: 'Digite seu telefone',
    value: null
  },
  'address.cep': {
    size: 4,
    offset: 8,
    type: 'text',
    name: 'address.cep',
    label: 'CEP',
    placeholder: 'Digite seu CEP',
    value: null,
    mask: '#####-###',
    hasSuccess: true,
    loading: 0
  },
  'address.uf': {
    size: 2,
    type: 'select',
    name: 'address.uf',
    label: 'UF',
    options: UFS,
    placeholder: '',
    value: null,
    disabled: true
  },
  'address.city.name': {
    size: 5,
    type: 'text',
    name: 'address.city.name',
    label: 'Cidade',
    placeholder: '',
    value: null,
    readonly: true
  },
  'address.district': {
    size: 5,
    type: 'text',
    name: 'address.district',
    label: 'Bairro',
    placeholder: '',
    value: null
  },
  'address.street': {
    size: 4,
    type: 'text',
    name: 'address.street',
    label: 'Endereço',
    placeholder: '',
    value: null,
    readonly: true
  },
  'address.number': {
    size: 2,
    type: 'text',
    name: 'address.number',
    label: 'Número',
    placeholder: '',
    value: null
  },
  'address.complement': {
    size: 2,
    offset: 2,
    type: 'text',
    name: 'address.complement',
    label: 'Complemento',
    placeholder: 'Ap., conj., etc',
    value: null
  },
  'address.latitude': {
    size: 2,
    type: 'hidden',
    hide: true,
    name: 'address.latitude',
    value: null
  },
  'address.longitude': {
    size: 2,
    type: 'hidden',
    hide: true,
    name: 'address.latitude',
    value: null
  }
}

const requiredFields = [
  'name', 'email', 'gender', 'dateOfBirth', 'cpf', 'contactPhone', 'address.cep', 'address.number'
]
const validations = {}
for (let requiredField of requiredFields) {
  validations[requiredField] = {}
  validations[requiredField].value = {}
  validations[requiredField].value.required = required
}
validations.dateOfBirth.value = {
  minLength: minLength(10)
}
validations['email'] = {
  value: {
    required,
    email
  }
}
export {formData, validations}
